/** Strings for the overlay components (C3). */
export const overlayCopy = {
  close: 'Close',
  cancel: 'Cancel',
  dismissNotification: 'Dismiss notification',
  typeToConfirm: (text: string) => `Type "${text}" to confirm`,
} as const
